import { render } from "./ConsultaUsuariosPage.vue?vue&type=template&id=15f9887b"
import script from "./ConsultaUsuariosPage.vue?vue&type=script&lang=js"
export * from "./ConsultaUsuariosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__